module.exports = __webpack_public_path__ + "20_mlf.jpg?24da04630e180e4f41514647e3548123";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/20_mlf.jpg
// module id = 172
// module chunks = 0